import { ArrowLeft, LockKeyhole, ShieldCheck } from "lucide-react";
import { useState } from "react";
import "@/Admin.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatError(detail) {
  if (!detail) return "Não foi possível entrar. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || JSON.stringify(item)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${API}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(formatError(data.detail));
      window.location.assign("/admin");
    } catch (submitError) {
      setError(submitError.message);
      setLoading(false);
    }
  };

  return (
    <main className="admin-login-page">
      <div className="admin-login-art"><div className="admin-art-number">30</div><p>ÁREA RESERVADA</p><h1>O cuidado também precisa de uma sala segura.</h1><span>Operações, leitores e uma vida protegida por trás do livro.</span></div>
      <section className="admin-login-card" aria-labelledby="admin-login-title">
        <a className="admin-back-link" href="/" data-testid="admin-login-home-link"><ArrowLeft size={15} /> voltar ao site</a>
        <div className="admin-lock-mark"><LockKeyhole size={19} /></div>
        <p className="admin-eyebrow">PAINEL DO ADMINISTRADOR</p>
        <h2 id="admin-login-title">Entrada privada.</h2>
        <p className="admin-login-copy">Acesso exclusivo para acompanhar pagamentos, configurar o Mercado Pago e ler o conteúdo completo.</p>
        <form className="admin-form" onSubmit={submit}>
          <label><span>E-mail</span><input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="username" required data-testid="admin-email-input" /></label>
          <label><span>Senha</span><input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required data-testid="admin-password-input" /></label>
          {error && <div className="admin-alert" role="alert" data-testid="admin-login-error">{error}</div>}
          <button className="admin-primary-button" type="submit" disabled={loading} data-testid="admin-login-submit">{loading ? "Verificando…" : "Entrar no painel"} <ShieldCheck size={16} /></button>
        </form>
        <small className="admin-security-note"><LockKeyhole size={13} /> Sessão protegida por cookie httpOnly. Nunca compartilhe sua senha.</small>
      </section>
    </main>
  );
}
